import { Edit, ListButton, TopToolbar } from 'react-admin';
import ChevronLeft from '@material-ui/icons/ChevronLeft';

import ProfessionForm from './ProfessionForm';

const ProfessionActions = ({ basePath }: any) => (
  <TopToolbar>
    <ListButton
      basePath={basePath}
      label='ra.action.back'
      icon={<ChevronLeft />}
    />
  </TopToolbar>
);

const ProfessionEdit = (props: any) => {
  return (
    <Edit actions={<ProfessionActions {...props} />} {...props}>
      <ProfessionForm />
    </Edit>
  );
};

export default ProfessionEdit;
